import { render, staticRenderFns } from "./ProxyTrafficOverviewDetails.vue?vue&type=template&id=96e8e96e&scoped=true"
import script from "./ProxyTrafficOverviewDetails.vue?vue&type=script&lang=js"
export * from "./ProxyTrafficOverviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8e96e",
  null
  
)

export default component.exports